import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';

@Component({
  selector: 'unsubscribe-page',
  templateUrl: 'unsubscribe.component.html',
  styleUrls: ['unsubscribe.component.scss']
})
export class UnsubscribePageComponent implements OnInit {

  email = null;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe(queryParams => {
      if (queryParams['md_email']) {
        this.email = queryParams['md_email']
      } else {
        this.router.navigate(['/']);
      }
    });
  }

}
